module.exports = __webpack_public_path__ + "img/RutasNacional.66b62a69.png";